import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';

class ContinueModal extends Component{

    componentDidMount(): void {
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#continueModal').modal('hide');  
    }

    closeAction = () => {
        $('#continueModal').on('hidden.bs.modal', function () {
        });
    };

    Continue =()=>{
        const { notificationReducer: { showAlert }, start} = this.props;
        start();
        $('#continueModal').modal('hide');
        
        showAlert({ type: 'success', message: 'Iniciando proceso...' });
            
    }

    render() {
        return (
                <div class="modal" tabindex="-1" role="dialog" id="continueModal" >
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                        <div class="modal-header text-light" style={{background: '#2d75bd', borderRadius: '0' }}>
                            <h5 class="modal-title">Mensaje.</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div className="row">
                                <div className="col-sm-12 col-md-12">
                                    <h2>¿Estas seguro que deseas iniciar Canal Moderno?</h2>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={this.closeConfirm}>NO</button>
                            <button type="button" className="btn btn-success" onClick={this.Continue}> Iniciar </button>                            
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

export default connect(
    mapStateToProps,
)(ContinueModal);
